import ChangePasswordForm from './ChangePasswordForm.jsx';

export {ChangePasswordForm}



// WEBPACK FOOTER //
// ./components/users/sub-view/change-password-form/index.js